// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"loading-spinner-module__loadingSpinner___28TD1","loading-spinner":"loading-spinner-module__loading-spinner___2Fcb5"};